/**
 * 延迟执行
 */
export default (delay = 1000) => {
    setTimeout(async () => {
        import(/* webpackChunkName: "zen-icon-symbol" */'@patsnap/common-snap-zen/src/icon-symbol/symbol');
    }, delay);
};
